import { Injectable } from "@angular/core";
import { Actions, Effect, ofType } from "@ngrx/effects";
import { UtilsAction } from "./utils.actions";
import { Store } from "@ngrx/store";
import { pipe } from "rxjs";
import { filter, map, share } from "rxjs/operators";
import { AppState } from "../../interfaces/app-state.interface";
import { UtilitiesService } from "../../services/utilities.service";
import { RealtimeService } from "../../services/realtime/realtime.service";
import { RealtimeHub } from "../../enum/realtime/realtime-hub.enum";

@Injectable()
export class UtilsEffects {


  @Effect({ dispatch: false }) getTimer$ = this.actions$
    .pipe(
			ofType(UtilsAction.getTimer),
      filter(
        action =>
          this.realtimeService.registerSubscribersAndCheckIfSubscriptionIsNeeded(
            RealtimeHub.Time
          ) === true
      ),
      map(action => {
        this.realtimeService
          .subscribeToTimeInfo()
          .pipe(
            filter(i => i),
          )
          .subscribe(body => {
            const time = body.DateTime ? body.DateTime.split(" ")[1] : "";
            this.onIncomingData({
              type: UtilsAction.getTimerSuccess,
              payload: time
            });
            this.onIncomingData({
              type: UtilsAction.getDateTimeSuccess,
              payload: body.DateTime
            });
          });
      }),
      share(),
    );

    constructor(
      private actions$: Actions<UtilsAction>,
      private realtimeService: RealtimeService,
      private store: Store<AppState>,
      private utils: UtilitiesService
    ) {}

  private onIncomingData(action: UtilsAction) {
    this.store.dispatch(action);
  }
}
